import { render, staticRenderFns } from "./IvfExpensesForm.vue?vue&type=template&id=323d053e&scoped=true"
import script from "./IvfExpensesForm.vue?vue&type=script&lang=js"
export * from "./IvfExpensesForm.vue?vue&type=script&lang=js"
import style0 from "./IvfExpensesForm.vue?vue&type=style&index=0&id=323d053e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d053e",
  null
  
)

export default component.exports